import {
    Tab as UnstyledTab,
    Tabs as UnstyledTabs,
    TabList as UnstyledTabList,
    TabPanel as UnstyledTabPanel
} from 'react-tabs';
import styled from 'styled-components';

const Tab = styled(UnstyledTab).attrs(() => ({
    selectedClassName: 'tab-selected',
    disabledClassName: 'tab-disabled'
}))`
  text-align: left;
  list-style: none;
  cursor: pointer;
  text-transform: uppercase;
  outline: none;
  color: #888;
  padding: 20px 40px 20px 0;

  &.tab-selected {
    color: ${props => props.theme.colors.primary};
    text-decoration: underline;
    border-bottom: none;
  }

  &.tab-disabled {
    color: #e0e0e0;
    cursor: not-allowed;
  }
`;

const Tabs = styled(UnstyledTabs)`
  color: ${props => props.theme.colors.darkgray};
  font-size: 16px;
`;

const TabList = styled(UnstyledTabList)`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  margin: 0;
  padding: 0;
  border-bottom: 1px solid #ccc;
`;

const TabPanel = styled(UnstyledTabPanel).attrs(() => ({ selectedClassName: 'tab-panel-selected', forceRender: true }))`
  display: none;
  &.tab-panel-selected {
    display: block;
  }
`;

Tab.tabsRole = 'Tab';
Tabs.tabsRole = 'Tabs';
TabList.tabsRole = 'TabList';
TabPanel.tabsRole = 'TabPanel';

export default { Tab, Tabs, TabList, TabPanel };



// WEBPACK FOOTER //
// ./src/components/organisms/Tabs.js